module.exports = __webpack_public_path__ + "static/media/header_menu_logo.a832bd2a.png";